module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_9006.4f11cc7a.png";